/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Generated on Tuesday, June 24, 2025 9:10:01 PM UTC
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  ISearchOutputIndex,
  ISearchTaskResult,
  ISearchConversationResult,
} from '../types/response.types'

export default new class SearchAPI extends RequestHandler {
  /****** POST methods *****/
  public async post_Index(
    searchTerm: string,
  ): Promise<ISearchOutputIndex> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/search`,
      data: {
        searchTerm
      },
    })
  }
  public async post_Tasks(
    searchTerm: string,
  ): Promise<ISearchTaskResult[]> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/search/tasks`,
      data: {
        searchTerm
      },
    })
  }
  public async post_Conversations(
    searchTerm: string,
  ): Promise<ISearchConversationResult[]> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/search/conversations`,
      data: {
        searchTerm
      },
    })
  }
}()
